import React from "react";
import Switch from "common/Buttons/Switch";
import Flex from "common/Boxes/Flex.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { useNewLook } from "features/newLook/NewLook.context.ts";
import { NEW_LOOK_TOGGLE_ID } from "testIds.ts";
import RowLabel from "common/Home/Sider/RowLabel.tsx";

interface NewLookToggleProps {
  /** New look menu rows: a leading icon. */
  icon?: React.ReactNode;
}

const NewLookToggle = ({ icon }: NewLookToggleProps) => {
  const { isNewLook, setIsNewLook } = useNewLook();
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);

  return (
    <Flex style={{ width: "100%" }}>
      <RowLabel icon={icon}>{t("user_info.new_look_label")}</RowLabel>
      <Switch
        aria-label={t("user_info.new_look_label")}
        checked={isNewLook}
        onChange={setIsNewLook}
        data-testid={NEW_LOOK_TOGGLE_ID}
      />
    </Flex>
  );
};

export default NewLookToggle;
